import { render, staticRenderFns } from "./table-cell-block.vue?vue&type=template&id=229cebf6&"
import script from "./table-cell-block.vue?vue&type=script&lang=js&"
export * from "./table-cell-block.vue?vue&type=script&lang=js&"
import style0 from "./table-cell-block.vue?vue&type=style&index=0&id=229cebf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports